import axios from 'axios';

const basePath = '/web-api/payments';

export const send = ({ provider = '', payload = '' }, config = {}) => {
    if (!provider) {
        throw '[Payment API : send()] data must have a `provider`';
    }
    return axios.post(
        basePath + '/' + provider,
        payload,
        config
    );
}

export default {
    send
}